import { IconCircleCheck, IconCircleX } from '@tabler/icons-react';
import { useTheme } from '@mui/material';

interface CompanyUserAdminStatusTagProps {
  is_company_admin: boolean;
}

function CompanyUserAdminStatusTag(props: CompanyUserAdminStatusTagProps) {
  const { is_company_admin } = props;
  const theme = useTheme();

  return (
    <>
      {is_company_admin ? (
        <IconCircleCheck color={theme.palette.success.main} />
      ) : (
        <IconCircleX color={theme.palette.error.main} />
      )}
    </>
  );
}

export default CompanyUserAdminStatusTag;
